import { useToast } from '@hover/blueprint';

import { client as apolloClient } from 'src/shared/graphql';
import { mutations } from 'src/shared/graphql/requests';
import { ViewerVersion, createJobShare } from 'src/shared/requests';

/**
 * This Regex was recomended from the following MDN eamil validation page:
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email#basic_validation
 */
const validEmailFormat =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const isValidEmail = (email: string): boolean => validEmailFormat.test(email);

const formatShareLink = (shareToken: string): string =>
  `${window.location?.protocol}//${window.location?.host}/wr/renderings/shared/${shareToken}`;

const copyLinkViaBrowserAPI = async (link: string): Promise<void> =>
  navigator.clipboard.writeText(link);

const requestJobShareToken = async (jobId: number): Promise<string> => {
  const jobShare = await createJobShare(jobId, ViewerVersion.RENDERINGS_HUB);
  return jobShare?.token || '';
};

const useConfiguredToast = () => useToast({ position: 'top', duration: 2500 });

const shareRenderingWithEmail = ({
  email,
  shareToken,
}: {
  email: string;
  shareToken: string;
}) =>
  mutations.sendRenderingShareEmail(apolloClient, {
    email,
    shareToken,
  });

export {
  isValidEmail,
  formatShareLink,
  copyLinkViaBrowserAPI,
  requestJobShareToken,
  shareRenderingWithEmail,
  useConfiguredToast,
};
